// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyArBqH8-4FThjjA5K93h7fYf7D8OHM7xyI",
  authDomain: "fabdiz-project-mangament.firebaseapp.com",
  projectId: "fabdiz-project-mangament",
  storageBucket: "fabdiz-project-mangament.appspot.com",
  messagingSenderId: "384317551782",
  appId: "1:384317551782:web:50abccd7d4f42a3163f067",
  measurementId: "G-CT184R85DD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firestore
export const firestore = getFirestore(app);
export const storage = getStorage(app);
export const messaging = getMessaging(app);